import {Buildings, BoundingBox, Layout, Bed} from '@phosphor-icons/react'
import clsx from 'clsx'
import {Spinner} from 'react-bootstrap'
import {LayoutProgressBar} from '../../../../features/layout/components/LayoutProgressBar'

import {DndProvider, useDrag, useDrop} from 'react-dnd'
import {CreatePhoneAssigmentModel, LayoutModelDto} from '../../../../model/assigment.model'
import {useFormContext} from 'react-hook-form'
import {useAssigment} from '../../../../hooks/limpieza/useAssigment'

const ItemTypes = {
  CELULAR: 'celular',
  ACTIVIDAD: 'actividad',
}

const DropLayout = ({
  layout,
  tipoData,
  onDropCelular,
  onDropActividad,
  onNavigateLayout,

  handleOpenActividades,
  handleOpenCelulares,
  handleActividades,
  handleCelulares,
}: {
  layout: LayoutModelDto
  tipoData: string
  onDropCelular: (dto: CreatePhoneAssigmentModel) => void
  onDropActividad: (actividadId: string, layout: LayoutModelDto, nivelAsignacion: string) => void
  onNavigateLayout: () => void

  handleOpenActividades: () => void
  handleOpenCelulares: () => void
  handleActividades: () => void
  handleCelulares: () => void
}) => {
  const {celularesDisponibles, setSelectedPhonesFn} = useAssigment()
  const [{isOver}, dropRef] = useDrop(() => ({
    accept: [ItemTypes.CELULAR, ItemTypes.ACTIVIDAD],
    drop: (item: {celularIds: string[]; type: string}) => {
      const celulares = item.celularIds || []
      let dto = {
        CelularIds: [...celulares],
        CampamentoId: '',
        ModuloId: '',
        PisoId: '',
        HabitacionId: '',
        NivelAsignacion: '',
      }
      if (tipoData === 'CAP') {
        dto = {
          ...dto,
          CampamentoId: layout.CampamentoId,
          NivelAsignacion: 'CAP',
        }
      } else if (tipoData === 'MOD') {
        dto = {
          ...dto,
          ModuloId: layout.ModuloId,
          NivelAsignacion: 'MOD',
        }
      } else if (tipoData === 'PIS') {
        dto = {
          ...dto,
          PisoId: layout.PisoId,
          NivelAsignacion: 'PIS',
        }
      } else if (tipoData === 'HAB') {
        dto = {
          ...dto,
          HabitacionId: layout.HabitacionId,
          NivelAsignacion: 'HAB',
        }
      }
      onDropCelular?.(dto)
    },
    collect: (monitor) => ({
      isOver: monitor.isOver({shallow: true}),
    }),
  }))

  const selectLayout = () => {
    if (tipoData === 'CAP') {
      const assigmentPhones = celularesDisponibles.filter((c) =>
        c.Asignaciones?.some((a) => a.CampamentoId === layout.CampamentoId),
      )
      setSelectedPhonesFn(assigmentPhones)
    } else if (tipoData === 'MOD') {
      const assigmentPhones = celularesDisponibles.filter((c) =>
        c.Asignaciones?.some((a) => a.ModuloId === layout.ModuloId),
      )
      setSelectedPhonesFn(assigmentPhones)
    } else if (tipoData === 'PIS') {
      const assigmentPhones = celularesDisponibles.filter((c) =>
        c.Asignaciones?.some((a) => a.PisoId === layout.PisoId),
      )
      setSelectedPhonesFn(assigmentPhones)
    } else if (tipoData === 'HAB') {
      const assigmentPhones = celularesDisponibles.filter((c) =>
        c.Asignaciones?.some((a) => a.HabitacionId === layout.HabitacionId),
      )
      setSelectedPhonesFn(assigmentPhones)
    }
  }

  return (
    <div
      className={clsx('card border card-xl-stretch min-w-350px mx-3 cursor-pointer', {
        'bg-light-success': isOver,
        'bg-light': !isOver,
      })}
      ref={dropRef}
    >
      <div
        className='card-header border-0 py-5 gap-4'
        onClick={selectLayout}
        onDoubleClick={onNavigateLayout}
      >
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>
            {tipoData === 'CAP' && layout.CampamentoNombre}
            {tipoData === 'MOD' && layout.NomenclaturaModulo}
            {tipoData === 'PIS' && layout.PisoNombre}
            {tipoData === 'HAB' && layout.NomenclaturaHabitacion}
          </span>
          {/* <LayoutProgressBar campa={campamento as any}></LayoutProgressBar> */}
        </h3>
        <div className='card-toolbar'>
          <BoundingBox className='me-2 text-muted mt-2' size={32} weight='duotone' />
        </div>
      </div>
      <div>
        <div className='card-p pt-5 bg-body flex-grow-1'>
          {tipoData === 'CAP' && (
            <div className='row g-0'>
              <div className='col mr-8'>
                <div className='fs-7 text-muted fw-semibold'>Módulos</div>
                <div className='d-flex align-items-center'>
                  <div className='fs-4 fw-bold'>{layout.TotalModulos || 0}</div>
                </div>
              </div>
              <div className='col'>
                <div className='fs-7 text-muted fw-semibold'>Pisos</div>
                <div className='fs-4 fw-bold'>{layout.TotalPisos || 0}</div>
              </div>
            </div>
          )}
          {tipoData === 'MOD' && (
            <div className='row g-0'>
              <div className='col mr-8'>
                <div className='fs-7 text-muted fw-semibold'>Pisos</div>
                <div className='d-flex align-items-center'>
                  <div className='fs-4 fw-bold'>{layout.TotalPisos || 0}</div>
                </div>
              </div>
              <div className='col'>
                <div className='fs-7 text-muted fw-semibold'>Habitaciones</div>
                <div className='fs-4 fw-bold'>{layout.TotalHabitaciones || 0}</div>
              </div>
            </div>
          )}
          {(tipoData === 'PIS' || tipoData === 'HAB') && (
            <div className='row g-0'>
              <div className='col mr-8'>
                <div className='fs-7 text-muted fw-semibold'>Habitaciones</div>
                <div className='d-flex align-items-center'>
                  <div className='fs-4 fw-bold'>{layout.TotalHabitaciones || 0}</div>
                </div>
              </div>
              <div className='col'>
                <div className='fs-7 text-muted fw-semibold'>Camas</div>
                <div className='fs-4 fw-bold'>{layout.TotalCamas || 0}</div>
              </div>
            </div>
          )}

          <div className='row g-0 mt-8'>
            <div
              className='col mr-8'
              onClick={handleActividades}
              onDoubleClick={handleOpenActividades}
            >
              <div className='fs-7 text-muted fw-semibold'>Programaciones</div>
              <div className='fs-4 fw-bold'>{layout.TotalProgramacion || 0}</div>
            </div>
            <div className='col' onClick={handleCelulares} onDoubleClick={handleOpenCelulares}>
              <div className='fs-7 text-muted fw-semibold'>Celulares</div>
              <div className='d-flex align-items-center'>
                <div className='fs-4 fw-bold'>{layout.TotalCelulares || 0}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export const ViewAssignLayout = ({
  data,
  tipoData,
  loadModulesLayout,
  loadFloorsLayout,
  loadHabiationsLayout,
  selectedOptionName,
  selectedOption,
  loadCampsLayout,
  isLoadingLayout,

  handleDropActividad,
  handleDropCelular,
}: {
  data?: any
  modules?: any
  tipoData?: string
  selectedOptionName?: any
  selectedOption?: any
  loadCampsLayout?: () => void
  loadModulesLayout?: (id: string, name: string) => void
  loadFloorsLayout?: (id: string, name: string) => void
  loadHabiationsLayout?: (id: string, name: string) => void
  handleDropActividad?: (actividadId: string, layout: LayoutModelDto) => void
  handleDropCelular?: (dto: CreatePhoneAssigmentModel) => void
  isLoadingLayout?: boolean
}) => {
  const {clearSelectedPhones, setSelectedPhonesFn} = useAssigment()

  const onNavigateLayout = (layout: LayoutModelDto) => {
    if (tipoData === 'CAP') {
      loadModulesLayout(layout.CampamentoId, layout.CampamentoNombre)
      clearSelectedPhones()
    }
    if (tipoData === 'MOD') {
      loadFloorsLayout(layout.ModuloId, layout.NomenclaturaModulo)
      clearSelectedPhones()
    }
    if (tipoData === 'PIS') {
      loadHabiationsLayout(layout.PisoId, layout.PisoNombre)
      clearSelectedPhones()
    }
  }

  const {watch} = useFormContext()

  const [{isOver}, dropRef] = useDrop(() => ({
    accept: [ItemTypes.CELULAR, ItemTypes.ACTIVIDAD],
    drop: (item: {celularIds: string[]; type: string}, monitor) => {
      if (monitor.didDrop()) {
        return
      }
      const celulares = item.celularIds || []
      const dataType = watch('TipoData')
      let dto = {
        CelularIds: [...celulares],
        CampamentoId: '',
        ModuloId: '',
        PisoId: '',
        HabitacionId: '',
        NivelAsignacion: '',
        SiteId: '',
      }
      if (dataType === 'CAP') {
        dto = {
          ...dto,
          SiteId: watch('SiteIdCurrent') || '',
          NivelAsignacion: 'CAP-ALL',
        }
      } else if (dataType === 'MOD') {
        dto = {
          ...dto,
          CampamentoId: watch('CampamentoId'),
          NivelAsignacion: 'MOD-ALL',
        }
      } else if (dataType === 'PIS') {
        dto = {
          ...dto,
          ModuloId: watch('ModuloId'),
          NivelAsignacion: 'PIS-ALL',
        }
      } else if (dataType === 'HAB') {
        dto = {
          ...dto,
          PisoId: watch('PisoId'),
          NivelAsignacion: 'HAB-ALL',
          ModuloId: watch('ModuloId'),
        }
      }
      handleDropCelular?.(dto)
    },
    collect: (monitor) => ({
      isOver: monitor.isOver({shallow: true}),
    }),
  }))

  return (
    <div className='p-6'>
      <div className='card card-custom shadow-sm'>
        <div className={'card-header'} style={{borderBottomWidth: '3px'}}>
          <ul className='breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0'>
            <li className={clsx('breadcrumb-item', 'text-dark')}>
              <div
                className='text-muted text-hover-primary cursor-pointer'
                onClick={() => loadCampsLayout && loadCampsLayout()}
              >
                CAMPAMENTOS
              </div>
            </li>

            {/* {selectedOptionName.site && (
              <li className={clsx('breadcrumb-item', 'text-dark')}>
                <div
                  className='text-muted text-hover-primary cursor-pointer'
                  onClick={() => loadCampsLayout && loadCampsLayout()}
                >
                  {selectedOptionName.site}
                </div>
              </li>
            )} */}
            {watch('CampamentoNombre') && (
              <>
                <li className='breadcrumb-item'>
                  <span className='bullet bg-gray-400 w-5px h-2px'></span>
                </li>
                <li className={clsx('breadcrumb-item', 'text-dark')}>
                  <div
                    className='text-muted text-hover-primary cursor-pointer'
                    onClick={() =>
                      loadModulesLayout &&
                      loadModulesLayout(selectedOption.camp, selectedOptionName.camp)
                    }
                  >
                    {watch('CampamentoNombre')}
                  </div>
                </li>
              </>
            )}

            {watch('ModuloNombre') && (
              <>
                <li className='breadcrumb-item'>
                  <span className='bullet bg-gray-400 w-5px h-2px'></span>
                </li>
                <li className={clsx('breadcrumb-item', 'text-dark')}>
                  <div
                    className='text-muted text-hover-primary cursor-pointer'
                    onClick={() => loadFloorsLayout(selectedOption.mod, selectedOptionName.mod)}
                  >
                    {watch('ModuloNombre')}
                  </div>
                </li>
              </>
            )}

            {watch('PisoNombre') && (
              <>
                <li className='breadcrumb-item'>
                  <span className='bullet bg-gray-400 w-5px h-2px'></span>
                </li>
                <li className={clsx('breadcrumb-item', 'text-dark')}>
                  <div
                    className='text-muted text-hover-primary cursor-pointer'
                    onClick={() => loadHabiationsLayout(selectedOption.pis, selectedOptionName.pis)}
                  >
                    {watch('PisoNombre')}
                  </div>
                </li>
              </>
            )}

            {watch('HabitacionNombre') && (
              <>
                <li className='breadcrumb-item'>
                  <span className='bullet bg-gray-400 w-5px h-2px'></span>
                </li>
                <li className={clsx('breadcrumb-item', 'text-dark')}>
                  <div className='text-muted text-hover-primary cursor-pointer'>
                    {watch('HabitacionNombre')}
                  </div>
                </li>
              </>
            )}
          </ul>
        </div>
        {isLoadingLayout ? (
          <div className='p-6'>
            <div className='card card-custom'>
              <div className='card-body'>
                <div className='d-flex justify-content-center align-items-center mb-2'>
                  <Spinner animation='border' />
                </div>
                <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                  Cargando
                </div>
              </div>
            </div>
          </div>
        ) : data.length > 0 ? (
          <div
            // className='card-body'
            className={clsx('card-body', {
              'bg-light-success': isOver,
            })}
            ref={dropRef}
            onClick={(e) => {
              const header = (e.target as HTMLElement).closest('.layout-header')

              if (e.target === e.currentTarget || header) {
                setSelectedPhonesFn([])
              }
            }}
          >
            <div className='layout-header py-5 d-flex flex-wrap'>
              <h4 className='d-flex align-items-center'>
                <BoundingBox className='me-2 text-muted' size={32} weight='duotone' />{' '}
                {tipoData === 'CAP' && 'CAMPAMENTOS'}
                {tipoData === 'MOD' && 'MODULOS'}
                {tipoData === 'PIS' && 'PISOS'}
                {tipoData === 'HAB' && 'HABITACIONES'}
              </h4>
            </div>
            <div className='d-flex flex-wrap gap-3 mt-3'>
              {data.map((layout: LayoutModelDto, index: any) => (
                <DropLayout
                  key={index}
                  layout={layout}
                  tipoData={tipoData}
                  onNavigateLayout={() => onNavigateLayout(layout)}
                  onDropCelular={handleDropCelular}
                  onDropActividad={handleDropActividad}
                  handleOpenActividades={() => {}}
                  handleOpenCelulares={() => {}}
                  handleActividades={() => {}}
                  handleCelulares={() => {}}
                />
              ))}
            </div>
          </div>
        ) : (
          <div className='p-6'>
            <div className='card card-custom'>
              <div className='card-body'>
                <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                  No hay información
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
